import { render, staticRenderFns } from "./ReviewPrompt.vue?vue&type=template&id=4691ef73&scoped=true"
import script from "./ReviewPrompt.vue?vue&type=script&lang=js"
export * from "./ReviewPrompt.vue?vue&type=script&lang=js"
import style0 from "./ReviewPrompt.vue?vue&type=style&index=0&id=4691ef73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4691ef73",
  null
  
)

export default component.exports